import type {
	APIWithPagination,
	DeepQueryParams,
	SWRConfigInterface,
} from "@gik/core/api/BaseAPIConfig";
import { wpApi } from "@gik/core/api/ky/wpApi";
import { useWPApi } from "@gik/core/api/swr/useWPApi";
import type WordpressPost from "@gik/core/models/wordpress/WordpressPost";
import PostsUrlBuilder from "./PostsUrlBuilder";

const path = "posts";

export interface PostsByTaxonomyParams extends APIWithPagination {
	taxonomyItemSlug?: string;
	taxonomySlug?: string;
}

function getParams(params: PostsByTaxonomyParams): DeepQueryParams {
	const builder = new PostsUrlBuilder()
		.withPerPage(params.perPage)
		.withPage(params.page)
		.withSingleTaxonomyItem({
			taxonomy: params?.taxonomySlug,
			terms: params?.taxonomyItemSlug,
		})
		.orderedByPriority();

	return builder.params;
}

export function getPostsByTaxonomy(
	params: PostsByTaxonomyParams,
): Promise<WordpressPost[]> {
	return wpApi
		.get(path, {
			searchParams: getParams(params),
		})
		.json<WordpressPost[]>();
}

export function usePostsByTaxonomy(
	params: PostsByTaxonomyParams,
	config?: SWRConfigInterface,
) {
	return useWPApi<WordpressPost[]>(
		params?.taxonomySlug && params?.taxonomyItemSlug ? path : null,
		getParams(params),
		config,
	);
}
